import * as types from './mutation-types'

const namespaced = true

const initialState = {
    isDarkMode: false
}

const mutations = {
    [types.TOGGLE_DARK_MODE](state, isDarkMode) {
        state.isDarkMode = isDarkMode
    }
}

const actions = {
    toggleDarkMode(context, isDarkMode) {
        context.commit(types.TOGGLE_DARK_MODE, isDarkMode)
    }
}

const getters = {
    isDarkMode(state) {
        return state.isDarkMode
    }
}

export default {
    namespaced,
    state: initialState,
    mutations,
    actions,
    getters
}
